<script lang="ts">
    import {OfferItem} from "../../entities/OfferItem";
    import {ModelType} from "../../entities/Model";
    import {LedExtras} from "../../entities/LedExtras";

    export let updateFormData: Function;
    export let currentItem: OfferItem;
    let ledExtras: LedExtras
    function setPanelLed() {
        ledExtras = new LedExtras(currentItem.extras.panelLed !== true, currentItem.extras.perimeterLed, currentItem.extras.linearLed, currentItem.extras.threeAxisLed, currentItem.extras.spotLed)
        let newRef = new LedExtras()
        Object.assign(newRef, ledExtras)
        updateFormData({
            extras: newRef
        })
    }

    function setPerimeterLed() {
        ledExtras = new LedExtras(currentItem.extras.panelLed, currentItem.extras.perimeterLed !== true, currentItem.extras.linearLed, currentItem.extras.threeAxisLed, currentItem.extras.spotLed,)
        let newRef = new LedExtras()
        Object.assign(newRef, ledExtras)
        updateFormData({
            extras: newRef
        })
    }

    function setLinearLed() {
        ledExtras = new LedExtras(currentItem.extras.panelLed, currentItem.extras.perimeterLed, currentItem.extras.linearLed !== true, false, false)
        let newRef = new LedExtras()
        Object.assign(newRef, ledExtras)
        updateFormData({
            extras: newRef
        })
    }

    function setThreeAxisLed() {
        ledExtras = new LedExtras(currentItem.extras.panelLed, currentItem.extras.perimeterLed, false, false, currentItem.extras.threeAxisLed !== true)
        let newRef = new LedExtras()
        Object.assign(newRef, ledExtras)
        updateFormData({
            extras: newRef
        })
    }

    function setSpotLed() {
        ledExtras = new LedExtras(currentItem.extras.panelLed, currentItem.extras.perimeterLed, false, currentItem.extras.spotLed !== true, false)
        let newRef = new LedExtras()
        Object.assign(newRef, ledExtras)
        updateFormData({
            extras: newRef
        })
    }
</script>
<div class="flex flex-wrap justify-evenly"
     style="display: {currentItem.measuredModel.model.type=== ModelType.BIOCLIMATIC? 'flex' : 'none' }">
    <!--//több is választható-->
    <div class="inline-flex relative text-center m-2"
         style="display: {currentItem.measuredModel.model.id === 1? 'inline-flex' : 'none' }">
        <input type="checkbox" name="extra" class="extra" id="panelLed"
               checked={currentItem.extras.panelLed}
               on:click={setPanelLed}/>
        <label class="cursor-pointer mx-3 img-label" for="panelLed">
            <img src="/img/gc_led_bioclimatic_panel.jpg" alt=""
                 class="h-20 rounded-2xl shadow-lg selected">
            <span class="left-0 absolute bottom-0 py-1 bg-black rounded text-sm bg-opacity-40 w-full rounded-br-2xl rounded-bl-2xl">LED Lamellákban</span>
        </label>
    </div>
    <div class="inline-flex items-center relative text-center m-2">
        <input type="checkbox" name="extra" id="perimeterLed" class="extra"
               checked={currentItem.extras.perimeterLed}
               on:click={setPerimeterLed}/>
        <label class="cursor-pointer mx-3 img-label" for="perimeterLed">
            <img src="/img/gc_led_bioclimatic_perimeter.jpg" alt=""
                 class="h-20 rounded-2xl shadow-lg selected">
            <span class="left-0 absolute bottom-0 py-1 bg-black rounded text-sm bg-opacity-40 w-full rounded-br-2xl rounded-bl-2xl">LED Keretprofilban</span>
        </label>
    </div>
</div>

<div class="flex flex-wrap justify-evenly"
     style="display: {currentItem.measuredModel.model.type === ModelType.PVC? 'flex' : 'none' }">
    <!--//csak egy válaszható-->
    <div class="inline-flex items-center relative text-center m-2">
        <input type="checkbox" name="extra" class="extra" id="spotLed"
               checked={currentItem.extras.spotLed}
               on:click={setSpotLed}/>
        <label class="cursor-pointer m-2 img-label" for="spotLed">
            <img src="/img/gc_led_pvc_spot.jpg" alt="" class="h-20 rounded-2xl shadow-lg">
            <span class="left-0 absolute bottom-0 py-1 bg-black rounded text-sm bg-opacity-40 w-full rounded-br-2xl rounded-bl-2xl">LED Spot</span>
        </label>
    </div>
    <div class="inline-flex items-center relative text-center m-2">
        <input type="checkbox" name="extra" class="extra" id="linearLed"
               checked={currentItem.extras.linearLed}
               on:click={setLinearLed}/>
        <label class="cursor-pointer m-2 img-label" for="linearLed">
            <img src="/img/gc_led_pvc_linear.jpg" alt="" class="h-20 rounded-2xl shadow-lg">
            <span class="left-0 absolute bottom-0 py-1 bg-black rounded text-sm bg-opacity-40 w-full rounded-br-2xl rounded-bl-2xl">LED Egyenes</span>
        </label>
    </div>
    <div class="inline-flex items-center relative text-center m-2">
        <input type="checkbox" name="extra" class="extra" id="threeAxisLed"
               checked={currentItem.extras.threeAxisLed}
               on:click={setThreeAxisLed}/>
        <label class="cursor-pointer m-2 img-label" for="threeAxisLed">
            <img src="/img/gc_led_pvc_3axis.jpg" alt="" class="h-20 rounded-2xl shadow-lg">
            <span class="left-0 absolute bottom-0 py-1 bg-black rounded text-sm bg-opacity-40 w-full rounded-br-2xl rounded-bl-2xl">LED 3 irányú</span>
        </label>
    </div>
</div>

